module.exports = __webpack_public_path__ + "img/ugly_or_beuty_tini_kicsi.19e04d2d.jpg";